/**
 *
 * Copyright 2020-2026 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

import type { NavigationMetricsOptions, SplunkOtelWebConfig } from '../../types'

// `spaMetrics` is deprecated in favor of `navigationMetrics`; `??` correctly treats an explicit
// `false`/`{}` on either key as a real value, so precedence (navigationMetrics wins when set) holds.
export function resolveNavigationMetricsConfig(
	options: Pick<SplunkOtelWebConfig, 'navigationMetrics' | 'spaMetrics'>,
): boolean | NavigationMetricsOptions {
	return options.navigationMetrics ?? options.spaMetrics ?? true
}
